"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEffectScrollControl = void 0;
var _react = require("react");
var useEffectScrollControl = exports.useEffectScrollControl = function useEffectScrollControl() {
  var HIDDEN = 'hidden';
  (0, _react.useEffect)(function () {
    var body = document.querySelector('body');
    var isScrollHidden = document.querySelector('body').style.getPropertyValue('overflow') === HIDDEN;
    var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
    if (!isScrollHidden) {
      body.style.cssText = "\n      overflow: hidden;\n      padding-right: ".concat(scrollBarGap, "px\n      ");
    }
    return function () {
      if (!isScrollHidden) {
        body.style.removeProperty('overflow');
        body.style.removeProperty('padding-right');
      }
    };
  }, []);
};